import React from "react";
import { HLSPlayer } from "../Video/HLSPlayer";

interface MobileFrameVideoProps {
  src: string;
  className?: string;
  isVideo?: boolean;
}

const MobileFrameVideo: React.FC<MobileFrameVideoProps> = ({
  src,
  className = "",
  isVideo = false,
}) => {
  const [isLoading, setIsLoading] = React.useState(true);

  return (
    <div className={`relative w-[280px] h-[580px] ${className} p-4`}>
      {/* Phone Frame with multiple layers for depth */}
      <div
        className="absolute inset-0 bg-gradient-to-b from-gray-800 via-gray-850 to-gray-900 rounded-[50px] shadow-[0_0_20px_rgba(0,0,0,0.4)] 
           before:absolute before:inset-0 before:rounded-[50px] before:bg-gradient-to-r before:from-gray-700/50 before:via-gray-800/50 before:to-gray-700/50
           after:absolute after:inset-0 after:rounded-[50px] after:bg-gradient-to-b after:from-white/5 after:to-transparent after:opacity-50"
      >
        {/* Metallic Edge Effect */}
        <div className="absolute inset-0 rounded-[50px] bg-gradient-to-tr from-gray-600/30 via-transparent to-gray-600/30 pointer-events-none"></div>

        {/* Side Frame Bevel */}
        <div className="absolute inset-[-1px] rounded-[51px] bg-gradient-to-r from-gray-700/50 via-gray-600/20 to-gray-700/50"></div>

        {/* Power Button - More detailed */}
        <div className="absolute right-[-2px] top-[120px] w-[4px] h-[60px] bg-gradient-to-b from-gray-600 via-gray-700 to-gray-600 rounded-l-lg shadow-[-2px_0_4px_rgba(0,0,0,0.3)]">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-white/10"></div>
        </div>

        {/* Volume Buttons - More detailed */}
        <div className="absolute left-[-2px] top-[100px] w-[4px] h-[35px] bg-gradient-to-b from-gray-600 via-gray-700 to-gray-600 rounded-r-lg shadow-[2px_0_4px_rgba(0,0,0,0.3)]">
          <div className="absolute inset-0 bg-gradient-to-l from-transparent to-white/10"></div>
        </div>
        <div className="absolute left-[-2px] top-[145px] w-[4px] h-[35px] bg-gradient-to-b from-gray-600 via-gray-700 to-gray-600 rounded-r-lg shadow-[2px_0_4px_rgba(0,0,0,0.3)]">
          <div className="absolute inset-0 bg-gradient-to-l from-transparent to-white/10"></div>
        </div>

        {/* Phone Notch - More realistic */}
        <div
          className="absolute top-3 left-1/2 transform -translate-x-1/2 w-[80px] h-[22px] bg-black rounded-full z-20 
             shadow-[inset_0_1px_3px_rgba(255,255,255,0.1),0_1px_2px_rgba(0,0,0,0.3)]"
        >
          <div className="absolute inset-[2px] rounded-full bg-gradient-to-b from-gray-800 to-black"></div>
        </div>

        {/* Phone Screen - Simplified */}
        <div
          className="absolute top-[8px] left-[8px] right-[8px] bottom-[8px] rounded-[42px] overflow-hidden 
             border border-gray-800/30"
        >
          {/* Content */}
          <div className="absolute inset-0 bg-white">
            {isVideo ? (
              <>
                <HLSPlayer
                  src={src}
                  autoPlay={true}
                  muted={true}
                  loop={true}
                  onLoadStart={() => setIsLoading(true)}
                  onCanPlay={() => setIsLoading(false)}
                />
                {isLoading && (
                  <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
                    <div className="w-8 h-8 border-4 border-gray-300 border-t-gray-800 rounded-full animate-spin"></div>
                  </div>
                )}
              </>
            ) : (
              <img
                src={src}
                className="w-full h-full object-cover"
                alt="screen content"
              />
            )}
          </div>
        </div>
      </div>

      {/* Multiple shadow layers for enhanced depth */}
      <div className="absolute inset-0 rounded-[50px] shadow-[0_10px_30px_rgba(0,0,0,0.3),0_4px_10px_rgba(0,0,0,0.2)] pointer-events-none"></div>
      <div className="absolute inset-[-4px] rounded-[54px] bg-gradient-to-b from-transparent via-black/5 to-black/10 pointer-events-none"></div>
    </div>
  );
};

export default MobileFrameVideo;
